module.exports = __webpack_public_path__ + "static/media/logo-white-green-hires.13a91025.png";